var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiveTransaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#1E2B45",
    fillOpacity: 0.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 13.2085V24.3785L14.1198 19.4985C13.7298 19.1085 13.0898 19.1085 12.6998 19.4985C12.3098 19.8885 12.3098 20.5185 12.6998 20.9085L19.2898 27.4985C19.6798 27.8885 20.3098 27.8885 20.6998 27.4985L27.2998 20.9185C27.6898 20.5285 27.6898 19.8985 27.2998 19.5085C26.9098 19.1185 26.2798 19.1185 25.8898 19.5085L20.9998 24.3785V13.2085C20.9998 12.6585 20.5498 12.2085 19.9998 12.2085C19.4498 12.2085 18.9998 12.6585 18.9998 13.2085Z",
    fill: "#F9FAFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveTransaction);
export default __webpack_public_path__ + "static/media/receiveTransaction.b9e45d085d467382f06e7a53cfc22a71.svg";
export { ForwardRef as ReactComponent };